'use client'

import { ChromaText } from '@/components/ui/chroma-text'

import { EASE, Eyebrow, restoreDashes, useReveal } from '@/components/page-kit'
import { ACCOUNTS } from './data'

/* `longDescription` is the section: opening sentence as the heading, remainder
   as the body, split at the first sentence boundary. Nothing rewritten. */

const [opening, ...rest] = restoreDashes(ACCOUNTS.longDescription).split(
  /(?<=\.)\s+/
)
const remainder = rest.join(' ')

export function AccountsOverview() {
  const block = useReveal<HTMLDivElement>(0.15)

  return (
    <section className="pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <div ref={block.ref} className="max-w-4xl">
          <Eyebrow>Overview</Eyebrow>

          <h2
            className="font-heading mt-6 text-2xl font-normal leading-[1.3] tracking-tight text-foreground sm:text-3xl lg:text-[40px] lg:leading-[1.25]"
            style={{
              opacity: block.shown ? 1 : 0,
              transform: block.shown ? 'none' : 'translateY(12px)',
              transition: `opacity 700ms ${EASE} 60ms, transform 700ms ${EASE} 60ms`,
            }}
          >
            <ChromaText>{opening}</ChromaText>
          </h2>

          {remainder && (
            <p
              className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg"
              style={{
                opacity: block.shown ? 1 : 0,
                transition: `opacity 700ms ${EASE} 240ms`,
              }}
            >
              {remainder}
            </p>
          )}
        </div>
      </div>
    </section>
  )
}
